/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function Codex({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" stroke="currentColor" strokeWidth={0.889} d="M5.559.717A3.6 3.6 0 0 1 7.369.47h.001c.787.091 1.492.423 2.122 1.015.074.07.154.104.207.12l.012.004.013.003q.092.023.188.012l.063-.012h.004a3.6 3.6 0 0 1 2.408.215v.001l.042.02.095.046a3.63 3.63 0 0 1 1.728 1.897l.002.005q.245.599.247 1.25v.258a3.3 3.3 0 0 1-.104.717l-.002.002a.6.6 0 0 0-.012.207l.014.07c.023.09.069.173.133.241l.005.005a3.55 3.55 0 0 1 .933 1.706c.232 1.141-.002 2.151-.704 3.065l-.104.127a3.6 3.6 0 0 1-1.741 1.099h-.005a.6.6 0 0 0-.174.087l-.05.042a.56.56 0 0 0-.141.215l-.002.006c-.165.477-.318.843-.592 1.205a3.6 3.6 0 0 1-2.942 1.458c-.936-.005-1.765-.343-2.504-1.037h-.001a.5.5 0 0 0-.18-.113l-.068-.02-.07-.011a.5.5 0 0 0-.211.023h-.004c-.274.089-.564.106-.93.102h-.001a3.5 3.5 0 0 1-1.534-.368h-.001c-.501-.248-.937-.61-1.274-1.057-.146-.193-.247-.323-.323-.476a5 5 0 0 1-.24-.58l-.06-.2a3.6 3.6 0 0 1-.01-1.812l-.003-.001a.6.6 0 0 0 .02-.212l-.003-.014-.003-.012-.022-.083a.5.5 0 0 0-.123-.192A3.5 3.5 0 0 1 .653 8.19l-.004-.01-.075-.224a3 3 0 0 1-.119-.7v-.007l-.01-.323q.006-.482.12-.948a3.71 3.71 0 0 1 1.995-2.33q.262-.109.528-.186l.007-.003a.53.53 0 0 0 .352-.357l.002-.006c.13-.466.353-.9.656-1.277l.002-.004A3.6 3.6 0 0 1 5.56.717ZM8.46 9.253a1.012 1.012 0 0 0 0 2.018l.013.002h3.244v-.002a1.01 1.01 0 0 0 .726-.274 1.013 1.013 0 0 0-.648-1.744zM4.623 4.855a1.011 1.011 0 0 0-1.144 1.452l.003.006.004.006 1.001 1.752-.992 1.677a1.01 1.01 0 1 0 1.737 1.03l1.293-2.182a1.01 1.01 0 0 0 .007-1.017l-1.29-2.262-.009-.011-.054-.081a1 1 0 0 0-.556-.37Z" /></svg>;
}
;